import * as React from 'react';
import { acqa, darkBlue, lightGreen, white } from '../../consts/variables';
import { CTA } from '../CTA';

export interface ICardGradientProps {
    title: string;
    subTitle?: string | JSX.Element;
    text?: string;
    image: string;
    btnText?: string;
    label?: string;
    onClick: () => any;
    ctaStyle?: 'white' | 'blue' | 'green';
}

const buttonSize: React.CSSProperties = {
    height: 48,
    padding: 15,
    paddingTop: 10,
    fontSize: 14,
};
const buttonColors: Record<ICardGradientProps['ctaStyle'], React.CSSProperties> = {
    white: { background: white, color: darkBlue },
    blue: { background: acqa, color: white },
    green: { background: lightGreen, color: white },
};

const ArrowColors: Record<ICardGradientProps['ctaStyle'], React.CSSProperties> = {
    white: { fill: white },
    blue: { fill: darkBlue },
    green: { fill: lightGreen },
};
export const CardGradient = (props: ICardGradientProps) => {
    const { title, subTitle, text, image, btnText, label, onClick } = props;

    // @TODO: Move CTA style to sass to be able to overwrite it in here properly
    const buttonStyle: React.CSSProperties = {
        ...buttonSize,
        ...buttonColors[props.ctaStyle ?? 'white'],
    };
    const buttonArrowStyle: React.CSSProperties = ArrowColors[props.ctaStyle ?? 'white'];
    return (
        <div className="cardBox">
            <img src={image} alt="CardBackground" />
            {Boolean(label) && <span className="cardLabel">{label}</span>}
            <div className="content">
                <div className="content-top">
                    <h3>{title}</h3>
                    {Boolean(subTitle) && <span>{subTitle}</span>}
                    {Boolean(text) && <p>{text}</p>}
                </div>
                <div>
                    {Boolean(btnText) && (
                        <CTA
                            wrapperStyle={buttonStyle}
                            arrowStyle={buttonArrowStyle}
                            onClick={onClick}
                        >
                            <div>{btnText}</div>
                        </CTA>
                    )}
                </div>
            </div>
        </div>
    );
};
